import { Link } from "react-router-dom";
import HeaderNav from "@/components/HeaderNav";
import KineticHero from "@/components/KineticHero";
import EditorialMarquee from "@/components/EditorialMarquee";
import ManifestoSection from "@/components/ManifestoSection";
import MethodSection from "@/components/MethodSection";
import TestimonialsSection from "@/components/TestimonialsSection";
import AdvisorProfile from "@/components/AdvisorProfile";
import FaqSection from "@/components/FaqSection";
import Footer from "@/components/Footer";
import FadeIn from "@/components/FadeIn";
import { ArrowRight } from "lucide-react";

function CtaBanner() {
  return (
    <section data-testid="cta-banner" className="relative overflow-hidden border-t border-stone-800/60">
      <div className="pointer-events-none absolute left-1/2 top-1/2 h-[420px] w-[720px] -translate-x-1/2 -translate-y-1/2 rounded-full bg-[#D4AF37]/[0.06] blur-[100px]" />
      <div className="relative mx-auto max-w-4xl px-6 py-24 text-center lg:py-32">
        <FadeIn>
          <p className="font-mono text-xs uppercase tracking-[0.3em] text-[#D4AF37]/80">Estimation gratuite & confidentielle</p>
          <h2 className="font-display mx-auto mt-6 max-w-2xl text-2xl font-normal leading-snug tracking-tight text-amber-100 sm:text-3xl lg:text-4xl">
            Connaître la valeur de votre bien<br />
            commence <em className="text-[#D4AF37]">par trois minutes.</em>
          </h2>
          <Link to="/estimation" data-testid="cta-banner-button" className="btn-gold mt-10">
            Commencer mon estimation <ArrowRight size={16} />
          </Link>
          <p className="mt-6 text-xs text-stone-500">
            Sans engagement · Rapport téléchargeable immédiatement
          </p>
        </FadeIn>
      </div>
    </section>
  );
}

export default function Landing() {
  return (
    <div data-testid="landing-page" className="bg-[#0B0B0D] text-[#F5F3EF]">
      <HeaderNav />
      <KineticHero />
      <EditorialMarquee />
      <ManifestoSection />
      <MethodSection />
      <TestimonialsSection />
      <CtaBanner />
      <AdvisorProfile />
      <FaqSection />
      <Footer />
    </div>
  );
}
